import type { IRowNode } from "ag-grid-community"
import { Button } from "~/components/reusable/Button"
import { EditSkuTagsDialog } from "./EditSkuTagsDialog"
import { type Tag, type TaggableVariant } from "./TagBadge"
import { TagsCellRenderer } from "./TagsCellRenderer"

type TagsCellProps = {
  entries: TaggableVariant[]
  value: Tag[] | null | undefined
  node?: IRowNode
}

export function TagsCell({ entries, value, node }: TagsCellProps) {
  if (node?.footer) return null
  if (!entries.length) return null

  const taggedEntriesCount = entries.filter((entry) => (entry.tags?.length ?? 0) > 0).length

  if (taggedEntriesCount === 0) {
    const variantIds = entries.map((entry) => entry.variantId)
    return (
      <div className="opacity-0 hover:opacity-100">
        <EditSkuTagsDialog
          variantIds={variantIds}
          variantsOverride={entries}
          customTrigger={
            <Button size="sm" variant="transparent">
              Add tag
            </Button>
          }
        />
      </div>
    )
  }

  return <TagsCellRenderer value={value} entries={entries} />
}
